import { PageSearchResults } from 'src/types/components';

import Link from 'components/BaseHelpers/Link';
import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import { PaginationLabels } from '../SearchPagination/SearchPagination';

import styles from './SearchResults.module.scss';

export type SearchResultsProps = {
  searchResults?: PageSearchResults;
  labels?: {
    resultLabels: {
      emptyStateLabel: string;
      noResultsFoundLabel: string;
      resultCountLabel: string;
    };
    paginationLabels: PaginationLabels;
  };
};

const EmptyResults = ({ label }: { label?: string }) => {
  return label ? <RichText field={label} className={styles.emptyResultsLabel} /> : <></>;
};

const ResultCount = ({
  label,
  count,
  total,
}: {
  label?: string;
  count?: string;
  total?: number;
}) => {
  if (!label || !count || !total) {
    return <></>;
  }
  const formattedLabel = label
    .replaceAll(`{count}`, count.toString())
    .replaceAll(`{total}`, total.toString());
  return <Text tag="p" className={styles.resultCount} field={formattedLabel} />;
};

const SearchResults = ({ searchResults, labels }: SearchResultsProps): JSX.Element => {
  const { total, results, range } = searchResults ?? {};
  if (!results) {
    return <EmptyResults label={labels?.resultLabels.emptyStateLabel} />;
  }
  if (results.length <= 0) {
    return <EmptyResults label={labels?.resultLabels.noResultsFoundLabel} />;
  }

  return (
    <>
      <ResultCount label={labels?.resultLabels.resultCountLabel} count={range} total={total} />
      <ul className={styles.main}>
        {results.map((result) => {
          const { title, eyebrow, description, path } = result;
          const fullPath = window.location.origin + path;
          return (
            <li key={result.path} className={styles.result}>
              <Link href={path} className={styles.link}>
                <div>
                  {!!eyebrow && <Text tag="p" field={eyebrow} className={styles.eyebrow} />}
                  <Text tag="h2" field={title} className={styles.heading} />
                  {!!description && <Text field={description} className={styles.description} />}
                  <Text tag="p" field={fullPath} className={styles.path} />
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default SearchResults;
